module.exports = __webpack_public_path__ + "static/media/otherProductsBg.06604543.svg";